import { GraftConfig as ProjectsGraftConfig } from '@graft/nuget-gc.webportals.projects'

import { readGraftWebserviceUrl } from '@common/config/utils/read-graft-webservice-url.util'

const projectsUrl = readGraftWebserviceUrl('PROJECTS')

if (projectsUrl) {
  ProjectsGraftConfig.host = projectsUrl
  ProjectsGraftConfig.stateless = true
}
